import React, { Fragment } from 'react';
import classNames from 'classnames';

import '../index.scss';
import seta from '../../../../assets/images/select_laranja.svg';

import voltar from '../../../../assets/images/voltar.svg';

const menuOptions = {
  defaultItems: [
    { title: 'Texto', icon: 'icon_box_text', type: 'Text', enabled: true },
    {
      title: 'Menu lista',
      icon: 'icon_menu_list',
      type: 'Menu',
      enabled: true,
    },
    { title: 'Imagem', icon: 'icon_image', type: 'Image', enabled: true },
    { title: 'Vídeo', icon: 'icon_video', type: 'Video', enabled: true },
    { title: 'Áudio', icon: 'icon_audio', type: 'Audio', enabled: true },
    {
      title: 'Documento',
      icon: 'icon_document',
      type: 'Document',
      enabled: true,
    },
    {
      title: 'Formulário',
      icon: 'icon_formulario',
      type: 'Form',
      enabled: true,
    },
    {
      title: 'Carrossel',
      icon: 'icon_carrossel',
      type: 'Carousel',
      enabled: true,
    },
  ],
  advancedItems: [
    { title: 'Coleta', icon: 'icon_coleta', type: 'Collect', enabled: true },
    { title: 'SMS', icon: 'icon_sms', type: 'SMS', enabled: true },
    { title: 'Email', icon: 'icon_email', type: 'EMAIL', enabled: true },
    // {title: 'Módulo', icon: 'icon_modulo', type: 'Module', enabled: true},
    { title: 'JSON API', icon: 'icon_json', type: 'API', enabled: true },
    { title: 'API V2', icon: 'icon_json', type: 'APIV2', enabled: true },

    { title: 'Script', icon: 'icon_script', type: 'Script', enabled: true },
    { title: 'Humano', icon: 'icon_humano', type: 'Human', enabled: true },
    {
      title: 'Condicional',
      icon: 'icon_condicional',
      type: 'Conditional',
      enabled: true,
    },
    {
      title: 'Mídia dinâmica',
      icon: 'icon_midia_dinamica',
      type: 'DynamicMedia',
      enabled: true,
    },
    {
      title: 'Grupo',
      icon: 'icon_group_orange',
      custom: true,
      type: 'Group',
      enabled: true,
    },
    {
      title: 'Direcionador',
      icon: 'icon_direcionador_orange',
      type: 'Redirect',
      custom: true,
      enabled: true,
    },
    {
      title: 'Transferência de Bot',
      icon: 'icon_bot_transfer_orange',
      type: 'BotTransfer',
      custom: true,
      enabled: true,
    },
    {
      title: 'Menu de IA',
      icon: 'icone-menu-ia',
      type: 'MenuAI',
      custom: true,
      enabled: true,
    },
  ],

  integrationItems: [
    { title: 'vTex', icon: '', type: 'vtexItems', enabled: true },
    { title: 'Zendesk', icon: '', type: 'ZendeskItems', enabled: true },
    { title: 'Jira', icon: '', type: 'JiraItems', enabled: true },
    { title: 'RD Station', icon: '', type: 'RDStationItems', enabled: true },
    { title: 'Glpi', icon: '', type: 'GlpiItems', enabled: true },
  ],

  vtexItems: [
    {
      title: 'Adicionar ao carrinho',
      icon: 'icon_adicionar_ao_carrinho',
      type: 'VTexAddToCart',
      enabled: true,
    },
    {
      title: 'Atualizar carrinho',
      icon: 'icon_atualizar_carrinho',
      type: 'VTexUpdateCart',
      enabled: true,
    },
    {
      title: 'Remover item do carrinho',
      icon: 'icon_remover_item_carrinho',
      type: 'VTexRemoveFromCart',
      enabled: true,
    },
    {
      title: 'Listar catálogo',
      icon: 'icon_listar_catalogo',
      type: 'VTexCatalogProducts',
      enabled: true,
    },
    {
      title: 'Listar carrinho',
      icon: 'icon_listar_carrinho',
      type: 'VTexOrderList',
      enabled: true,
    },
    {
      title: 'Buscar produto do catalógo',
      icon: 'icon_buscar_produto_catalogo',
      type: 'VTexCatalogProduct',
      enabled: true,
    },
    {
      title: 'Buscar produto do carrinho',
      icon: 'icon_buscar_produto_carrinho',
      type: 'VTexCartProduct',
      enabled: true,
    },

    {
      title: 'Checkout',
      icon: 'icon_checkout',
      type: 'VTexCheckout',
      enabled: true,
    },
  ],

  ZendeskItems: [
    {
      title: 'Novo Ticket',
      icon: 'icon_create_request',
      type: 'ZendeskCreateRequest',
      enabled: true,
    },
    {
      title: 'Listar Tickets',
      icon: 'icon_list_request',
      type: 'ZendeskListRequests',
      enabled: true,
    },
    {
      title: 'Mostrar Ticket',
      icon: 'icon_show_request',
      type: 'ZendeskShowRequest',
      enabled: true,
    },
    {
      title: 'Listar Comentários',
      icon: 'icon_list_comments',
      type: 'ZendeskListComments',
      enabled: true,
    },
    {
      title: 'Inserir Comentário',
      icon: 'icon_insert_comment',
      type: 'ZendeskInsertComment',
      enabled: true,
    },
    {
      title: 'Anexar Arquivo',
      icon: 'icon_attach_file',
      type: 'ZendeskAttachFile',
      enabled: true,
    },

    {
      title: 'Finalizar Ticket',
      icon: 'icon_update_status',
      type: 'ZendeskUpdateStatusRequest',
      enabled: true,
    },
  ],

  JiraItems: [
    {
      title: 'Novo ticket',
      icon: 'icon_create_request',
      type: 'JiraCreateIssue',
      enabled: true,
    },
    {
      title: 'Listar projetos',
      icon: 'icon_list_request',
      type: 'JiraListProjects',
      enabled: true,
    },
    {
      title: 'Tipos ticket',
      icon: 'icon_list_request',
      type: 'JiraListRequestypes',
      enabled: true,
    },
    {
      title: 'Listar prioridades',
      icon: 'icon_list_request',
      type: 'JiraListPriorities',
      enabled: true,
    },
    {
      title: 'Listar Status',
      icon: 'icon_list_request',
      type: 'JiraListStatus',
      enabled: true,
    },
    {
      title: 'Listar tickets',
      icon: 'icon_list_request',
      type: 'JiraListIssues',
      enabled: true,
    },
    {
      title: 'Checar ticket',
      icon: 'icon_show_request',
      type: 'JiraShowIssue',
      enabled: true,
    },
    {
      title: 'Listar Comentários',
      icon: 'icon_list_comments',
      type: 'JiraListComments',
      enabled: true,
    },
    {
      title: 'Inserir Comentário',
      icon: 'icon_insert_comment',
      type: 'JiraInsertComment',
      enabled: true,
    },
    {
      title: 'Anexar Arquivo',
      icon: 'icon_attach_file',
      type: 'JiraAttachFile',
      enabled: true,
    },
    {
      title: 'Finalizar Ticket',
      icon: 'icon_update_status',
      type: 'JiraUpdateStatusIssue',
      enabled: true,
    },
  ],

  RDStationItems: [
    {
      title: 'Campo',
      icon: 'bloco_campo_rd',
      type: 'RdStationInput',
      isSvg: true,
      enabled: true,
    },
    {
      title: 'Cadastrar Lead',
      icon: 'bloco_criar_lead',
      type: 'RdStationSubmitLead',
      isSvg: true,
      enabled: true,
    },
  ],

  GlpiItems: [
    {
      title: 'Novo Ticket',
      icon: 'icon_create_request',
      type: 'GlpiCreateRequest',
      enabled: true,
    },
    {
      title: 'Listar Tickets',
      icon: 'icon_list_request',
      type: 'GlpiListRequests',
      enabled: true,
    },
    {
      title: 'Mostrar Ticket',
      icon: 'icon_show_request',
      type: 'GlpiShowRequest',
      enabled: true,
    },
    {
      title: 'Listar Comentários',
      icon: 'icon_list_comments',
      type: 'GlpiListComments',
      enabled: true,
    },
    {
      title: 'Inserir Comentário',
      icon: 'icon_insert_comment',
      type: 'GlpiInsertComment',
      enabled: true,
    },
    {
      title: 'Anexar Arquivo',
      icon: 'icon_attach_file',
      type: 'GlpiAttachFile',
      enabled: true,
    },
    {
      title: 'Finalizar Ticket',
      icon: 'icon_update_status',
      type: 'GlpiUpdateStatusRequest',
      enabled: true,
    },
    {
      title: 'Listar Grupos',
      icon: 'icon_list_comments',
      type: 'GlpiListGroups',
      enabled: true,
    },
  ],
};

const renderItemElement = (item) => {
  const { custom, icon, title, isSvg } = item;

  if (!icon) {
    if (title) {
      return <span>{title}</span>;
    }
    return null;
  }

  if (!custom) {
    const src = `/assets/images/icons/builder/${icon}.${isSvg ? 'svg' : 'png'}`;
    return (
      <Fragment>
        <img src={src} alt="" />
        <span>{title}</span>
      </Fragment>
    );
  }

  return (
    <div className="radio-icon-title-container">
      <img
        className="option-img"
        src={require(`../../../../assets/images/${icon}.svg`)}
        alt=""
      />
      <span className="option-title">{title}</span>
    </div>
  );
};

const MenuItem = ({ item, handleContextMenuOption }) => {
  return (
    <>
      <li className="builder__context__menu-item">
        <a
          className={classNames({
            disabled: !item.enabled,
          })}
          onClick={(e) => handleContextMenuOption(e, item)}
          href="#/"
        >
          {renderItemElement(item)}
        </a>
      </li>
    </>
  );
};

const handlevoltar = (e, handleOpenSecondary) => {
  e.preventDefault();
  e.stopPropagation();

  const li = e.target.parentElement.parentElement;

  let idx = 0;
  let child = li;
  while ((child = child.previousSibling) != null) idx++;

  const menuRoot = li.parentElement.parentElement.parentElement;

  const left = menuRoot.offsetLeft;
  const top = menuRoot.offsetTop;

  handleOpenSecondary('integrationItems', { top, left });
};
const MenuItems = ({
  items,
  handleContextMenuOption,
  variant,
  handleOpenSecondary,
}) => {
  return (
    <>
      {(variant === 'vtexItems' && (
        <li className="builder__context__menu-item">
          <img
            alt=""
            src={voltar}
            className="img-item-title-menu-integracao"
            disabled
            alt=""
          />
          <a onClick={(e) => handlevoltar(e, handleOpenSecondary)} href="#/">
            <span>voltar</span>
          </a>
        </li>
      )) ||
        (variant === 'ZendeskItems' && (
          <li className="builder__context__menu-item">
            <img
              src={voltar}
              className="img-item-title-menu-integracao"
              disabled
              alt="voltar"
            />
            <a onClick={(e) => handlevoltar(e, handleOpenSecondary)} href="#/">
              <span>voltar</span>
            </a>
          </li>
        )) ||
        (variant === 'JiraItems' && (
          <li className="builder__context__menu-item">
            <img
              src={voltar}
              className="img-item-title-menu-integracao"
              disabled
              alt="voltar"
            />
            <a onClick={(e) => handlevoltar(e, handleOpenSecondary)} href="#/">
              <span>voltar</span>
            </a>
          </li>
        )) ||
        (variant === 'GlpiItems' && (
          <li className="builder__context__menu-item">
            <img
              src={voltar}
              className="img-item-title-menu-integracao"
              disabled
              alt="voltar"
            />
            <a onClick={(e) => handlevoltar(e, handleOpenSecondary)} href="#/">
              <span>voltar</span>
            </a>
          </li>
        )) ||
        (variant === 'RDStationItems' && (
          <li className="builder__context__menu-item">
            <img
              alt=""
              src={voltar}
              className="img-item-title-menu-integracao"
              disabled
            />
            <a onClick={(e) => handlevoltar(e, handleOpenSecondary)} href="#/">
              <span>voltar</span>
            </a>
          </li>
        )) ||
        ''}

      {items.map((item) => (
        <>
          <MenuItem
            item={item}
            key={item.type}
            handleContextMenuOption={handleContextMenuOption}
            handleOpenSecondary={handleOpenSecondary}
          />
          {variant === 'integrationItems' && (
            <img src={seta} className="secondary-menu-container-img" alt="" />
          )}
        </>
      ))}
    </>
  );
};

export default ({
  style,
  handleContextMenuOption,
  variant,
  handleOpenSecondary,
}) => {
  return (
    <div
      className="builder__context"
      style={{ ...style, marginTop: 0, marginLeft: 0 }}
    >
      <div className="builder__context--position">
        <div className="builder__context__arrow" />
        <ul className="builder__context__items" style={{ width: 180 }}>
          <MenuItems
            items={
              (variant && menuOptions[variant]) || menuOptions.defaultItems
            }
            handleContextMenuOption={handleContextMenuOption}
            variant={variant}
            handleOpenSecondary={handleOpenSecondary}
          />
        </ul>
      </div>
    </div>
  );
};
